export const prependUrlScheme = (input: string): string => {
  if (
    !input ||
    !input.trim() ||
    input.startsWith('http://') ||
    input.startsWith('https://')
  ) {
    return input;
  }

  return `https://${input}`;
};
